import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const deleteDocsOrgToDoc = async ({ docId, orgId }) => {
  return await request.delete(
    `/Docs/deleteOrgFromDoc?docId=${docId}&orgId=${orgId}`,
    null,
    'При изменении удалении адресата произошла ошибка документа произошла ошибка',
    'Error'
  );
};

const useDeleteDocsOrgToDoc = () => {
  const mutation = useMutation(deleteDocsOrgToDoc, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocsOrgToDocDelete: mutation.isLoading,
    deleteDocsOrgToDoc: mutation.mutateAsync,
  };
};

export default useDeleteDocsOrgToDoc;
